(() => {

  const initialiseQuantity = (form) => {
    const input = form.querySelector('[data-quantity-input]');
    const minus = form.querySelector('[data-quantity-minus]');
    const plus = form.querySelector('[data-quantity-plus]');
    if (!input || !minus || !plus) return;

    const setQuantity = (value) => {
      input.value = Math.max(1, Number.parseInt(value, 10) || 1);
    };

    minus.addEventListener('click', () => setQuantity(Number(input.value) - 1));
    plus.addEventListener('click', () => setQuantity(Number(input.value) + 1));
    input.addEventListener('change', () => setQuantity(input.value));
  };

  const initialiseGallery = (root) => {
    if (root.dataset.haseGalleryReady === 'true') return;

    const mainImage = root.querySelector('.hase-product__media img');
    const thumbnails = [...root.querySelectorAll('[data-gallery-image-src]')];
    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => {
        const nextImage = thumbnail.dataset.galleryImageSrc;
        if (!nextImage) return;

        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = nextImage;
        mainImage.alt = thumbnail.dataset.galleryImageAlt || mainImage.alt;

        thumbnails.forEach((item) => {
          const isActive = item === thumbnail;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
      });
    });

    const controls = root.querySelector('[data-gallery-controls]');
    if (controls && thumbnails.length > 1) {
      controls.hidden = false;
      const step = (direction) => {
        const activeIndex = thumbnails.findIndex((item) => item.classList.contains('is-active'));
        const nextIndex = (Math.max(0, activeIndex) + direction + thumbnails.length) % thumbnails.length;
        thumbnails[nextIndex].click();
        thumbnails[nextIndex].scrollIntoView({ block: 'nearest', inline: 'nearest' });
      };
      controls.querySelector('[data-gallery-previous]').addEventListener('click', () => step(-1));
      controls.querySelector('[data-gallery-next]').addEventListener('click', () => step(1));
    }

    root.dataset.haseGalleryReady = 'true';
  };

  const initialise = (root) => {
    initialiseGallery(root);
    if (root.dataset.haseVariantsReady === 'true') return;

    const variantsNode = root.querySelector('[data-hase-variants]');
    const form = root.querySelector('.hase-product-form');
    if (!variantsNode || !form) return;

    const variants = JSON.parse(variantsNode.textContent);
    const money = JSON.parse(root.querySelector("[data-hase-money]")?.textContent || "{}");
    const optionGroups = [...form.querySelectorAll('[data-option-position]')];
    const idInput = form.querySelector('[data-variant-id]');
    const button = form.querySelector('[data-add-button]');
    const currentPrice = root.querySelector('[data-current-price]');
    const regularPrice = root.querySelector('[data-regular-price]');
    const savings = root.querySelector('[data-savings]');

    const updateVariant = () => {
      const values = optionGroups.map((group) => group.querySelector('[data-option-value]:checked')?.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === values[index]));

      if (!variant) {
        idInput.value = '';
        button.disabled = true;
        button.textContent = root.dataset.unavailableLabel || 'Unavailable';
        return;
      }

      idInput.value = variant.id;
      button.disabled = !variant.available;
      button.textContent = variant.available ? button.dataset.addLabel || 'Add to cart' : root.dataset.soldOutLabel || 'Sold out';
      currentPrice.textContent = money[variant.id]?.price || String(variant.price / 100);
      const mainImage = root.querySelector('.hase-product__media img');
      if (mainImage && variant.featured_image?.src) {
        mainImage.removeAttribute('srcset');
        mainImage.src = variant.featured_image.src;
        mainImage.alt = variant.featured_image.alt || mainImage.alt;
        const normalise = src => src.split('?')[0].replace(/^https?:/, '');
        root.querySelectorAll('[data-gallery-image-src]').forEach(thumbnail => {
          const active = normalise(thumbnail.dataset.galleryImageSrc) === normalise(variant.featured_image.src);
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-pressed', String(active));
        });
      }

      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const savingAmount = variant.compare_at_price - variant.price;
        regularPrice.hidden = false;
        regularPrice.textContent = money[variant.id]?.compare || String(variant.compare_at_price / 100);
        savings.hidden = false;
        savings.textContent = `${root.dataset.savingsLabel || 'Save'} ${money[variant.id]?.saving || String(savingAmount / 100)}`;
      } else {
        regularPrice.hidden = true;
        regularPrice.textContent = '';
        savings.hidden = true;
        savings.textContent = '';
      }
    };

    optionGroups.forEach((group) => group.addEventListener('change', updateVariant));
    initialiseQuantity(form);
    updateVariant();
    root.dataset.haseVariantsReady = 'true';
  };

  const initialiseAll = () => document.querySelectorAll('[data-hase-product]').forEach(initialise);

  document.addEventListener('DOMContentLoaded', initialiseAll);
  document.addEventListener('shopify:section:load', initialiseAll);
  initialiseAll();
})();
